import Vue from 'vue'
var u = navigator.userAgent;
let timesDiff = 0;
let deviceInfo = {};
let currentUser = {};
class Utils {


    constructor() {

    }

    getDeviceInfo() {
        let deviceType = 'ANDROID';
        if (this.isIOS()) {
            deviceType = 'IOS'
        }
        if (this.isPC()) {
            deviceType = 'PC'
        }
        deviceInfo = {
            deviceType: deviceType
        }
        return deviceInfo;

    }

    getGoodsShelfCode() {
        let v = new Vue();
        let goodsShelfCode = v.constantConfig.goodsShelfCode;

        return goodsShelfCode;
    }

    getMerchantCode() {
        let v = new Vue();
        let merchantCode = v.constantConfig.merchantCode;
        return merchantCode;
    }

    isAndroid() {
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
        return isAndroid
    }

    isIOS() {
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        return isIOS
    }

    isPC() {
        let Agents = ["Android", "iPhone",
            "SymbianOS", "Windows Phone",
            "iPad", "iPod"
        ];
        let flag = true;
        for (let v = 0; v < Agents.length; v++) {
            if (u.indexOf(Agents[v]) > 0) {
                flag = false;
                break;
            }
        }
        return flag;
    }

    isWeixin() {
        let ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            return true;
        } else {
            return false;　
        }
    }

    /**
     * [checkPhoneNumber 校验手机号]
     * @param {string} 
     * @return {boolean}  
     */
    checkPhoneNumber(str) {
        var myreg = /^[1][3,5,6,7,8,9][0-9]{9}$/;
        if (!myreg.test(str)) {
            return false;
        } else {
            return true;
        }
    }


    /**
     * 根据属性值找出数组元素对象
     * @param {*} arr 
     * @param {*} property 
     * @param {*} value 
     */
    getPropertyObj(arr, property, value) {
        let index = 0;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i][property] == value) {
                index = i;
                break
            }
        }
        return arr[index];
    }

    /**
     * 根据属性值找出数组所在的index
     * @param {*} arr 
     * @param {*} property 
     * @param {*} value 
     */
    getPropertyIndex(arr, property, value) {
        let index = 0;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i][property] == value) {
                index = i;
                break
            }
        }
        return index;
    }

    /**
     * 数组某个属性提出组成新数组
     * @param {*} arr 
     * @param {*} property 
     */
    getPropertyValues(arr, property) {
        let resultArr = [];
        for (var i = 0; i < arr.length; i++) {
            resultArr.push(arr[i][property]);
        }
        return resultArr;
    }

    /**删除数组中的某一个对象
     _arr:数组
     _obj:需删除的对象
     */
    removeArray(_arr, _obj) {
        let length = _arr.length;
        for (let i = 0; i < length; i++) {
            if (_arr[i] === _obj) {
                if (i === 0) {
                    _arr.shift(); //删除并返回数组的第一个元素
                    return _arr;
                } else if (i === length - 1) {
                    _arr.pop(); //删除并返回数组的最后一个元素
                    return _arr;
                } else {
                    _arr.splice(i, 1); //删除下标为i的元素
                    return _arr;
                }
            }
        }
    }

    /**删除数组中的空对象
     _arr:数组
     */
    removeEmptyArrayEle(arr) {
        let resultArr = [];
        for (var i = 0; i < arr.length; i++) {
            if (arr[i] != null) {
                resultArr.push(arr[i]);
            }
        }
        return resultArr;
    }

    /**
     * 
     * @param {手机号} str 
     */
    isPoneAvailable(str) {
        var myreg = /^[1][1,2,3,4,5,6,7,8,9][0-9]{9}$/;
        if (!myreg.test(str)) {
            return false;
        } else {
            return true;
        }
    }

    /**
     * 保存服务器时间，date格式
     * @param {*string} time 
     */
    refreshCurrentTimeDiff(time) {
        if (time) {
            timesDiff = new Date().getTime() - new Date(time).getTime()
        }
    }

    /**
     * 
     * @param {*string} strdate 
     */
    newDate(strdate) {
        var arr = strdate.split(/[- : \/]/);
        var date;
        if (arr.length == 2) {
            date = new Date(arr[0] + '/' + arr[1] + '/1');
        }
        if (arr.length == 3) {
            date = new Date(arr[0] + '/' + arr[1] + '/' + arr[2]);
        }
        if (arr.length == 6) {
            date = new Date(arr[0] + '/' + arr[1] + '/' + arr[2] + ' ' + arr[3] + ':' + arr[4] + ':' + arr[5]);
        }
        return date;
    }

    /**
     * 获取当前时间，date格式
     */
    getCurrentTime() {
        return new Date(new Date().getTime() - timesDiff);
    }

    writeAuthCode(options) {
        let canvas = document.getElementById(options.canvasId);
        canvas.width = options.width || 200
        canvas.height = options.height || 50
        let ctx = canvas.getContext('2d'); /**创建一个canvas对象*/
        ctx.textBaseline = "middle";
        ctx.fillStyle = this.randomColor(180, 255); /**这个范围的颜色作背景看起来清晰一些*/
        ctx.fillRect(0, 0, options.width, options.height);
        for (let i = 0; i < options.txt.length; i++) {
            let txt = options.txt.charAt(i); /**让每个字不一样*/
            ctx.font = '40px SimHei';
            ctx.fillStyle = this.randomColor(50, 160); /**随机生成字体颜色*/
            ctx.shadowOffsetY = this.randomNum(-3, 3);
            ctx.shadowBlur = this.randomNum(-3, 3);
            ctx.shadowColor = "rgba(0, 0, 0, 0.3)";
            let x = options.width / (options.txt.length + 1) * (i + 1);
            let y = options.height / 2;
            let deg = this.randomNum(-30, 30);
            /**设置旋转角度和坐标原点*/
            ctx.translate(x, y);
            ctx.rotate(deg * Math.PI / 180);
            ctx.fillText(txt, 0, 0);
            /**恢复旋转角度和坐标原点*/
            ctx.rotate(-deg * Math.PI / 180);
            ctx.translate(-x, -y);
        }
        /**1~4条随机干扰线随机出现*/
        for (let i = 0; i < this.randomNum(1, 4); i++) {
            ctx.strokeStyle = this.randomColor(40, 180);
            ctx.beginPath();
            ctx.moveTo(this.randomNum(0, options.width), this.randomNum(0, options.height));
            ctx.lineTo(this.randomNum(0, options.width), this.randomNum(0, options.height));
            ctx.stroke();
        }
        /**绘制干扰点*/
        for (let i = 0; i < options.width / 6; i++) {
            ctx.fillStyle = this.randomColor(0, 255);
            ctx.beginPath();
            ctx.arc(this.randomNum(0, options.width), this.randomNum(0, options.height), 1, 0, 2 * Math.PI);
            ctx.fill();
        }
    }

    /**随机数字**/
    randomNum(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
    }

    /**随机颜色**/
    randomColor(min, max) {
        let r = this.randomNum(min, max);
        let g = this.randomNum(min, max);
        let b = this.randomNum(min, max);
        return "rgb(" + r + "," + g + "," + b + ")";
    }

    //格式化金额
    formatCurrency(num) {
        if (num) {
            //将num中的$,去掉，将num变成一个纯粹的数据格式字符串
            num = num.toString().replace(/\$|\,/g, '');
            //如果num不是数字，则将num置0，并返回
            if ('' == num || isNaN(num)) { return 'Not a Number ! '; }
            //如果num是负数，则获取她的符号
            var sign = num.indexOf("-") > 0 ? '-' : '';
            //如果存在小数点，则获取数字的小数部分
            var cents = num.indexOf(".") > 0 ? num.substr(num.indexOf(".")) : '';
            cents = cents.length > 1 ? cents : ''; //注意：这里如果是使用change方法不断的调用，小数是输入不了的
            //获取数字的整数数部分
            num = num.indexOf(".") > 0 ? num.substring(0, (num.indexOf("."))) : num;
            //如果没有小数点，整数部分不能以0开头
            if ('' == cents) { if (num.length > 1 && '0' == num.substr(0, 1)) { return 'Not a Number ! '; } }
            //如果有小数点，且整数的部分的长度大于1，则整数部分不能以0开头
            else { if (num.length > 1 && '0' == num.substr(0, 1)) { return 'Not a Number ! '; } }
            //针对整数部分进行格式化处理，这是此方法的核心，也是稍难理解的一个地方，逆向的来思考或者采用简单的事例来实现就容易多了
            /*
              也可以这样想象，现在有一串数字字符串在你面前，如果让你给他家千分位的逗号的话，你是怎么来思考和操作的?
              字符串长度为0/1/2/3时都不用添加
              字符串长度大于3的时候，从右往左数，有三位字符就加一个逗号，然后继续往前数，直到不到往前数少于三位字符为止
             */
            for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
                num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3));
            }
            //将数据（符号、整数部分、小数部分）整体组合返回
            return (sign + num + cents);
        } else {
            return 0;
        }
    }

    setCurrentUser(user) {
        currentUser = user;
    }

    getCurrentUser() {
        return currentUser;
    }

    /**
     * 获取url参数
     * @param {*string} url 
     */
    parseUrl(url) {
        var res = {},
            query = url.split('?')[1];
        if (!query) return {}
        var queryArr = query.split("&");

        queryArr.forEach(function(item) {
            var t = item.split("=")
            var key = t[0],
                value = t[1];
            res[key] = value;
        });
        return res
    }



}
let utils = new Utils();
export default utils;


// WEBPACK FOOTER //
// ./src/common/utils.js